import { createFileRoute } from "@tanstack/react-router";
import { PatientIndex } from "@/features/patients";
import { requirePerm } from "@/lib/auth/guards";

/**
 * `/patients` — the index. The address is already the nav door.
 *
 * The screen is drawn from `GET /v1/patients` (`features/patients/
 * patient-index.tsx`): name and phone, the server's page, the status
 * control, the inactivated tag and the hidden-records sentence on the wire
 * `DECISIONS.md` (06-10-2026) names. The 03:04 UTC row carries optional
 * `patientId`. This file still does not declare `/patients/$patientId`:
 * the document has no record read; the id is drawn only on the index row.
 * `textSearch` and `status` are not search params of this route: what was
 * typed and what was chosen do not belong in the page URL (`DECISIONS.md`
 * 21-09-2026 and 05-10-2026).
 */
export const Route = createFileRoute("/_authenticated/patients")({
  beforeLoad: requirePerm("VIEW_PATIENT"),
  component: PatientIndex,
});
